const baseVal = 18;
const pxToRem = px => `${parseFloat((parseInt(px, 10) / parseInt(baseVal, 10)).toPrecision(4))}rem`;

export default pxToRem



// WEBPACK FOOTER //
// ./src/utils/pxtorem.js